import React from "react";
import "./AboutDiscover.scss";

import { Link } from "react-router-dom";

import { ReactComponent as SideBtn } from "../../assets/svg/side-btn.svg";

import HomeContact1 from "../../assets/images/homeContact-1.png";

const AboutDiscover = () => {
  return (
    <section className="section aboutDiscover">
      <article className="aboutDiscover__container container">
        <div className="aboutDiscover__container--contents">
          <div className="aboutDiscover__container--contents-text">
            <h3>
              Radiksez Outsourcing Agency —
              <span>Igniting Excellence Through Dedication & Innovation</span>
            </h3>

            <p>
              At Radiksez, we are passionate about helping businesses achieve
              their full potential through the power of human expertise and AI
              technology. We work with businesses to provide all-round support
              for your business from software development to quality assurance
              testing, from social media management to AI & ML validation - all
              without the hassle of hiring! <br /> <br />
              We are committed to delivering best-in-class work that exceeds
              your expectations. We implement rigorous vetting processes and
              quality control measures to guarantee the highest standards of
              service. <br /> <br />
              Contact us today for a free consultation and discover how we can
              help you thrive in today&apos;s competitive landscape.
            </p>

            <Link to="/case-studies" className="aboutDiscover__contents-btn">
              <button className="aboutDiscover__btn">
                <span>Contact Us</span>
              </button>
              <SideBtn />
            </Link>
          </div>
          <figure className="aboutDiscover__container--contents-img">
            <img
              src={HomeContact1}
              width={600}
              height={391}
              title="picture of a person working on a laptop"
              alt="HomeContact1"
            />
          </figure>
        </div>
      </article>
    </section>
  );
};

export default AboutDiscover;
